module.exports = __webpack_public_path__ + "44abcef69f99913a9395d548f72f20ec.pdf";